{
  "name": "igsu-frontend",
  "version": "4.4.0",
  "contributors": [
    "Alejandro Soriano Gomez",
    "Víctor Martín Serra",
    "Jonathan Alberto Alvarado Batista"
  ],
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "build:portal:dev": "ng build igsu-portal --configuration development",
    "build:bo:dev": "ng build igsu-backoffice --configuration development",
    "build:bo:staging": "ng build igsu-backoffice --configuration staging",
    "build:portal:staging": "ng build igsu-portal --configuration staging",
    "build:portal:prod": "ng build igsu-portal --configuration production",
    "build:bo:prod": "ng build igsu-backoffice --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "pnpm run test:portal && pnpm run test:bo",
    "test:portal": "ng test igsu-portal --no-watch",
    "test:bo": "ng test igsu-backoffice --no-watch",
    "test:watch:portal": "ng test igsu-portal",
    "test:watch:bo": "ng test igsu-backoffice",
    "start:portal:local": "ng serve igsu-portal --configuration local --open --host local.3ddigitalvenue.com --port 4400",
    "start:portal:dev": "ng serve igsu-portal --configuration development --open --host local.3ddigitalvenue.com --port 4400",
    "start:portal:dev:hmr": "ng serve igsu-portal --hmr --configuration development --open --host local.3ddigitalvenue.com --port 4400",
    "start:portal:staging": "ng serve igsu-portal --configuration staging --open --host local.3ddigitalvenue.com --port 4400",
    "start:portal:prod": "ng serve igsu-portal --configuration production --open --host local.3ddigitalvenue.com --port 4400",
    "start:bo:local": "ng serve igsu-backoffice --configuration local --open --host local.3ddigitalvenue.com --port 4400",
    "start:bo:dev": "ng serve igsu-backoffice --configuration development --open --host local.3ddigitalvenue.com --port 4400",
    "start:bo:dev:hmr": "ng serve igsu-backoffice --hmr --configuration development --open --host local.3ddigitalvenue.com --port 4400",
    "start:bo:staging": "ng serve igsu-backoffice --configuration staging --open --host local.3ddigitalvenue.com --port 4400",
    "start:bo:prod": "ng serve igsu-backoffice --configuration production --open --host local.3ddigitalvenue.com --port 4400",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "lint:portal": "ng lint igsu-portal",
    "lint:bo": "ng lint igsu-backoffice",
    "doc:portal": "npx compodoc -p tsconfig.portal.doc.json -s -w -d docs/igsu-portal --hideGenerator --disableGraph",
    "doc:bo": "npx compodoc -p tsconfig.bo.doc.json -s -w -d docs/igsu-backoffice --hideGenerator --disableGraph",
    "e2e:portal": "playwright test",
    "e2e:portal:typecheck": "tsc --noEmit -p projects/igsu-portal/e2e",
    "e2e:portal:ui": "playwright test --ui",
    "e2e:portal:debug": "playwright test --debug",
    "e2e:portal:report": "playwright show-report",
    "e2e:portal:ci": "pnpm run build:portal:dev && playwright test",
    "e2e:bo": "playwright test --config=projects/igsu-backoffice/playwright.config.ts",
    "e2e:bo:ui": "playwright test --config=projects/igsu-backoffice/playwright.config.ts --ui",
    "e2e:bo:debug": "playwright test --config=projects/igsu-backoffice/playwright.config.ts --debug",
    "e2e:bo:report": "playwright show-report",
    "e2e:bo:typecheck": "tsc --noEmit -p projects/igsu-backoffice/e2e"
  },
  "private": true,
  "dependencies": {
    "@3ddv/dvm-internal": "2.8.2",
    "@3ddv/igsu-models": "workspace:*",
    "@3ddv/ngx-dvm-internal": "~4.2.6",
    "@3ddv/software-division-components": "2.6.0",
    "@3ddv/utils-igsu": "4.2.2",
    "@angular/animations": "^21.1.0",
    "@angular/cdk": "^21.1.0",
    "@angular/common": "^21.1.0",
    "@angular/compiler": "^21.1.0",
    "@angular/core": "^21.1.0",
    "@angular/forms": "^21.1.0",
    "@angular/platform-browser": "^21.1.0",
    "@angular/platform-browser-dynamic": "^21.1.0",
    "@angular/router": "^21.1.0",
    "@floating-ui/dom": "~1.7.6",
    "@ng-icons/core": "~33.1.0",
    "@ng-icons/lucide": "~33.1.0",
    "@popperjs/core": "^2.11.8",
    "@spartan-ng/brain": "0.0.1-alpha.499",
    "@stripe/stripe-js": "~2.1.11",
    "@tanstack/angular-table": "^8.21.3",
    "@tiptap/core": "^3.20.4",
    "@tiptap/extension-link": "^3.20.4",
    "@tiptap/extension-placeholder": "^3.20.4",
    "@tiptap/extension-underline": "^3.20.4",
    "@tiptap/starter-kit": "^3.20.4",
    "animejs": "^4.3.6",
    "class-variance-authority": "^0.7.1",
    "clsx": "^2.1.1",
    "embla-carousel": "~8.6.0",
    "embla-carousel-angular": "^19.0.0",
    "module-alias": "~2.2.3",
    "ngx-toastr": "~18.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "zod": "~3.22.4",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@3ddv/ticketing-config": "^1.1.2",
    "@angular-builders/custom-webpack": "~17.0.0",
    "@angular-eslint/builder": "^21.0.1",
    "@angular-eslint/schematics": "^21.0.1",
    "@angular/build": "^21.1.0",
    "@angular/cli": "^21.1.0",
    "@angular/compiler-cli": "^21.1.0",
    "@compodoc/compodoc": "~1.1.24",
    "@componizer/schematics": "~0.0.7",
    "@eslint/js": "^9.39.1",
    "@playwright/test": "~1.62.1",
    "@schematics/angular": "~17.0.0",
    "@smarttools/eslint-plugin-rxjs": "^1.0.22",
    "@tailwindcss/postcss": "~4.1.18",
    "@types/braintree-web-drop-in": "~1.39.3",
    "@types/file-saver": "~2.0.7",
    "@types/node": "~20.10.0",
    "angular-eslint": "^21.0.1",
    "angular-http-server": "~1.12.0",
    "autoprefixer": "~10.4.16",
    "eslint": "^9.39.1",
    "eslint-config-prettier": "^10.1.8",
    "eslint-import-resolver-typescript": "^4.4.4",
    "eslint-plugin-boundaries": "^5.4.0",
    "eslint-plugin-prettier": "^5.5.5",
    "eslint-plugin-unicorn": "^60.0.0",
    "file-saver": "~2.0.5",
    "filesaver": "~0.0.13",
    "jsdom": "~30.0.1",
    "postcss": "~8.4.31",
    "prettier": "~3.1.0",
    "prettier-plugin-tailwindcss": "~0.6.14",
    "tailwindcss": "~4.1.18",
    "tailwindcss3": "npm:tailwindcss@3.3.7",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.46.4",
    "vitest": "~4.1.10"
  },
  "packageManager": "pnpm@11.5.2"
}
